<div class="container">
    <lib-error-outline-svg></lib-error-outline-svg>
    <p class="title">No se pudo completar la operación intentelo más tarde</p>
</div>